import type { FaireProductEntity } from "../../entity_types/product";

export const p_2zy6jtwwkt: FaireProductEntity = {
  token: "p_2zy6jtwwkt",
  type: "product",
  name: "Sterling Silver Moissanite Pave Octagon Men's Ring",
  brandToken: "b_75net88q84",
  brandName: "Atlanta Jewelers Supply",
  imageUrl:
    "https://cdn.faire.com/fastly/4569b902698e805ccbec9c40a15e0942492025cad62c5822e38aa071536190e6.jpeg",
  galleryImageUrls: [],
  priceDollars: 90.06,
  description: "",
  tags: [],
  msrpDollars: 180.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:50.049Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
